import React, { Component } from 'react';
import Inherit from './core/inherit';
import Loading from './elements/Loading';
import AppController from './app.controller';
import { LoginForm } from './elements/login';
import { ClockoutRouter } from '@clockout-dev/clockout-components';

class App extends Inherit(AppController, Component) {
    state = {
        loading: true,
        fi: null,
        authenticated: false
    };
    
    clockoutUX(authenticated) {
        return authenticated ? <ClockoutRouter /> : <LoginForm onContinue={this.handleLoginClick.bind(this)} />;
    }

    render() {
        const { loading, authenticated } = this.state;

        return (
            <div style={{ backgroundColor: 'white' }}>
                {loading ? <Loading backgroundColor={'rgb(22, 21, 19)'} spinnerColor={'rgb(27, 152, 133)'} /> : this.clockoutUX(authenticated)}
            </div>
        );
    }
}

export default App;
